import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Container, TextField, Button, Typography, Box, Divider, Alert } from '@mui/material';
import { GoogleLogin } from '@react-oauth/google';
const API_URL = process.env.REACT_APP_API_URL;
 console.log('API_URL:', API_URL);
const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    const mensajeAcceso = location.state?.mensaje || null;
    console.log('Intento de login:', { email, password });

    const handleSubmit = async (e) => {
    e.preventDefault();
    try {   
        const response = await fetch(`${API_URL}/login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include', // permite que se establezca la cookie desde el servidor
            body: JSON.stringify({ email, password })
        });
        if (response.ok) {
            const data = await response.json();
            localStorage.setItem('token', data.token);
            localStorage.setItem('userRole', data.role);
            localStorage.setItem('userId', data.id);
            localStorage.setItem('username', data.username);
            navigate('/');
        } else {
            // Loguear status y body para diagnosticar
            let bodyText = '';
            try {
                bodyText = await response.text();
            } catch (e) {
                bodyText = '<no body>';
            }
            console.error('Error en el inicio de sesión', response.status, bodyText);
            alert(`Error en el inicio de sesión: ${response.status} - ${bodyText}`);
        }
    } catch (error) {
        console.error('Error en la solicitud:', error);
    }
};

    const handleGoogleSuccess = async (credentialResponse) => {
        try {
            console.log('Google login exitoso, enviando token al backend');
            const response = await fetch(`${API_URL}/auth/google`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify({ token: credentialResponse.credential })
            });
            
            if (response.ok) {
                const data = await response.json();
                console.log('Respuesta del backend:', data);
                localStorage.setItem('token', data.token);
                localStorage.setItem('userRole', data.role);
                localStorage.setItem('userId', data.id);
                localStorage.setItem('username', data.username);
                if (data.avatar) {
                    localStorage.setItem('userAvatar', data.avatar);
                }
                navigate('/');
            } else {
                console.error('Error al iniciar sesión con Google');
                alert('Error al iniciar sesión con Google');
            }
        } catch (error) {
            console.error('Error en la solicitud de Google:', error);
            alert('Error al conectar con el servidor');
        }
    };

    const handleGoogleError = () => {
        console.log('Login con Google falló');
        alert('No se pudo iniciar sesión con Google');
    };

    return (
        <Container maxWidth="xs">
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    mt: 8,
                    
                }}
            >
                <Typography component="h1" variant="h5">
                    L o g i n
                </Typography>
                {mensajeAcceso && (
                    <Alert severity="warning" sx={{ mt: 2, width: '100%' }}>
                        {mensajeAcceso}
                    </Alert>
                )}
                <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="Email Address"
                        name="email"
                        autoComplete="email"
                        autoFocus
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        sx={{ mt: 1 , border: '1px solid #7B68EE' }}/>
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Password"
                        type="password"
                        id="password"
                        autoComplete="current-password"
                        value={password}
                        sx={{ mt: 1 , border: '1px solid #7B68EE' }}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3, mb: 2 , backgroundColor: '#7B68EE'}}
                    >
                        Login
                    </Button>
                    
                    <Divider sx={{ my: 2 }}>O</Divider>
                    
                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                        <GoogleLogin
                            onSuccess={handleGoogleSuccess}
                            onError={handleGoogleError}
                            text="signin_with"
                            shape="rectangular"
                            theme="filled_blue"
                            size="large"
                            width="100%"
                        />
                    </Box>
                </Box>
            </Box>
        </Container>
    );
};

export default Login;